import DraftPage from "../order-sim/DraftPage"
import { oioEngine } from "./engine"

/** /oio-sim/:threadId/draft: the shared draft page with the OIO's paper. */
export default function OioDraftPage() {
  return <DraftPage engine={oioEngine} />
}
